import { BaseHandler } from '@/lib/filter/base-translator/handler';
import { answer } from 'shared/api/query/configs.json';
import { reverseEdge } from 'shared/api/query/edges';

const childrenFn = (varName) => ([
  {
    attr: reverseEdge(answer.edges.propertyValues),
    model: answer.model,
    var: varName,
  },
]);

export class AnswerFilterHandler {
  constructor() {
    this.baseHandler = new BaseHandler({
      model: answer.model,
      childrenFn,
      isFilterMode: true,
    });
  }

  Translate(tree) {
    return this.baseHandler.Translate(tree);
  }
}
